import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=1a59d5a3&scoped=true"
import script from "./text-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-field.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./text-field.vue?vue&type=style&index=0&id=1a59d5a3&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59d5a3",
  null
  
)

export default component.exports